module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lte-alert",
    class: _vm.alertClass
  }, [(_vm.closable) ? _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeBtnClick
    }
  }, [_vm._v("×")]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38518c7e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/alert/alert.vue
// module id = 16
// module chunks = 0